import React from "react";
import DisbursementList from "./disbursementList/DisbursementList";

const Disbursement = () => {
  return <DisbursementList />;
};

export default Disbursement;
